import * as Sentry from '@sentry/vue'
import { router } from './router'

export function install(app) {
  const buildMode = import.meta.env.VITE_BUILD_MODE || 'local'
  if (import.meta.env.PROD && buildMode !== 'local') {
    Sentry.init({
      app,
      dsn: 'https://396fd4287b03003c55ac63d29bf8307e@o10989.ingest.sentry.io/4505705923608576',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        // Sentry.replayIntegration(),
      ],
      // environment: 'production' || 'dev' || 'staging', // from vite.config.js
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', 'https://goteamup.com/api/'],
      // Performance Monitoring
      tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      // replaysSessionSampleRate: 0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      initialScope: {
        tags: {
          buildMode,
        },
      },
    })
  }
}
